export function selfPercentileColor(p: number | null): string {
  if (p == null) return '#94a3b8';
  if (p >= 90) return '#22c55e';
  if (p >= 70) return '#4ade80';
  if (p >= 30) return '#94a3b8';
  if (p >= 10) return '#fb923c';
  return '#f87171';
}

export function ordinal(n: number): string {
  const s = ['th', 'st', 'nd', 'rd'];
  const v = n % 100;
  return n + (s[(v - 20) % 10] || s[v] || s[0]);
}

export interface AxisStat {
  current: number;
  percentile: number | null;
  mean: number;
  stdev: number;
  count: number;
  regime: string;
  firstObs: string | null;
  lastObs: string | null;
}

export interface SelfPercentiles {
  q: AxisStat;
  v: AxisStat;
  composite: AxisStat;
}
